import React from 'react';
import { motion } from 'framer-motion';
import GradientText from './reactbits/GradientText/GradientText';
import ShinyText from './reactbits/ShinyText/ShinyText';
import Reveal from './ui/Reveal';

function ContactCTA() {
  return (
    <div className="collaborate-section">
      <div className="container">
        <div className="row">
          <Reveal
            className="col-lg-12 wow animate fadeInUp"
            delay={0.08}
          >
            <div className="collaborate-wrapper">
              <div className="section-title-5">
                <span>
                  <GradientText as="span" className="nalexus-pill-text" animationSpeed={10}>
                    LET'S COLLABORATE
                  </GradientText>
                </span>
                <h2>
                  Ready to <br />
                  <span>
                    <ShinyText
                      text="work with us?"
                      className="nalexus-heading-shine"
                      color="#f1ede3"
                      shineColor="#ffd369"
                      speed={2.6}
                    />
                  </span>
                </h2>
                <div className="get-btn">
                  <motion.a whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.98 }} className="primary-btn3 nalexus-cta" href="/contact">
                    Get a Free Consultation
                  </motion.a>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}

export default ContactCTA;





